import { Component, computed, inject, Injector, Input, OnInit, signal } from '@angular/core';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { ModuleType } from '@fi-shared/types/module-type';
import { StatisticService } from '@fi-app/shared/statistic/statistic.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { TabsModuleBase } from '@fi-app/utilities/tabs/tabs-module-base';
import { UserPreferencesService } from '@fi-shared/fi-shared-services/user-preferences.service';
import { FiDisplayType } from '@fi-app/shared/types/display-type';
import { FiItemsListType } from '@fi-shared/fi-items-list/fi-items-list-type';
import { FiTagsSelectionTypes } from '@fi-app/components/items-list/enums';

@Component({
    selector: 'fi-media-bank-list-view-state',
    templateUrl: './media-bank-list-view-state.component.html',
    standalone: false,
})
export class FiMediaBankListViewStateComponent extends TabsModuleBase implements OnInit {
    @Input() mediaListViewSettings: ListViewSettingModel;

    private userPreferencesService = inject(UserPreferencesService);
    private statisticService = inject(StatisticService);

    protected currentListDisplayType = signal<FiDisplayType>(FiDisplayType.List);
    protected isCurrentListDisplayTypeList = computed(() => this.currentListDisplayType() === FiDisplayType.List);

    protected showAdd = signal<boolean>(false);
    protected readonly FiStateNames = FiStateNames;

    constructor(injector: Injector) {
        super(injector);
    }

    protected getLimitedTagIds(): number[] | undefined {
        if (this.mediaListViewSettings.ListType === FiTagsSelectionTypes.AllTags) {
            return undefined;
        }
        return this.mediaListViewSettings.ListViewTags.map((tag) => tag.Id);
    }

    public ngOnInit(): void {
        this.initCurrentListDisplayType();
        this.statisticService.Visit(ModuleType.MediaBank);
        this.showAdd.set(this.stateAccessCheckService.isStateAllowedForCurrentUser(FiStateNames.MediaBank.Add));
    }

    protected initCurrentListDisplayType(): void {
        const preferredDisplayType = this.userPreferencesService.getListDisplayType(FiItemsListType.MediaBank);
        if (typeof preferredDisplayType !== 'number') {
            this.updateCurrentListDisplayType(FiDisplayType.List);
        } else {
            this.currentListDisplayType.set(preferredDisplayType);
        }
    }

    protected updateCurrentListDisplayType(type: number) {
        this.currentListDisplayType.set(type);
        this.userPreferencesService.saveListDisplayType(FiItemsListType.MediaBank, type);
    }

    // getSideListOptionsTags(): ISideListOptionsItem[] {
    //     return this.listData?.ListViewSettings.ListViewTags.map((tag: IListViewTag) => ({
    //         value: tag.Id,
    //         text: tag.Name,
    //     }));
    // }
}
